import { Link } from '@remix-run/react';
import { Button } from '~/components/ui/button';

export function NotFound() {
  return (
    <section className="flex flex-col text-center items-center justify-center h-dvh w-dvw gap-4">
      <div className="space-y-2 p-4">
        <h3 className="text-4xl">404: Pagina niet gevonden</h3>
        <p className="font-medium text-2xl">We konden de pagina niet vinden.</p>
      </div>
      <Link to="/">
        <Button>Terug naar home</Button>
      </Link>
    </section>
  );
}
